import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import ClientsFee from '@/features/clients-fee'

export const Route = createFileRoute('/_authenticated/clients-fee/')({
  component: ClientsFee,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Frais de clients`,
      },
    ],
  }),
})
